/*
 *
 * Home reducer
 *
 */
import produce from 'immer';
import {
  FLUSH_STATE_HOME,
} from './constants';

export const initialState = {
  loading: false,
  error: false,
};

/* eslint-disable default-case, no-param-reassign */
const homeReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE_HOME:
        return initialState;
    }
  });

export default homeReducer;
